import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetSeoUrlsFailed, EGetSeoUrlsActionType } from './types';

export const getSeoUrlsFailed: () => TGetSeoUrlsFailed = actionGenerator<EGetSeoUrlsActionType.Failed>(
  EGetSeoUrlsActionType.Failed,
);
